import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconInfinitySg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={11}
    fill="none"
    viewBox="0 0 20 11"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-infinity-sg_svg__a)"
      d="M15.438.031C17.938.031 20 2.062 20 4.563v.906c0 2.5-2.063 4.531-4.563 4.562-1.187 0-2.343-.5-3.187-1.344L10 6.438l-2.281 2.25C6.875 9.531 5.719 10 4.53 10A4.535 4.535 0 0 1 0 5.469v-.907C0 2.063 2.031.032 4.531 0 5.72 0 6.875.5 7.72 1.344L10 3.594l2.25-2.25C13.094.5 14.25.03 15.438.03Zm-9.126 7.25 2.25-2.25-2.25-2.281a2.53 2.53 0 0 0-1.78-.719A2.52 2.52 0 0 0 2 4.562v.907A2.568 2.568 0 0 0 4.531 8.03c.657 0 1.313-.281 1.782-.75ZM18 5.47v-.907c0-1.406-1.156-2.562-2.563-2.53a2.53 2.53 0 0 0-1.78.718l-2.25 2.281 2.25 2.25c.468.469 1.124.75 1.78.75A2.574 2.574 0 0 0 18 5.47Z"
    />
    <defs>
      <linearGradient
        id="icon-infinity-sg_svg__a"
        x1={20}
        x2={4.39}
        y1={-3}
        y2={16.512}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconInfinitySg;
